// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shimmer-account-profile-info .shimmer.shimmer-avatar{
    width: 133px !important;
    height: 133px !important;
}

.shimmer-account-profile-info > div {
    line-height: 1;
    margin: 0px;
    padding: 0px;
    gap: 0px;
}

.shimmer-account-profile-info {
    display: flex;  
    gap: 20px;              
}


.shimmer-account-profile-info .grid.shimmer-text.grid-gap-20 {
    width: 400px;
    gap: 20px;
}

.shimmer-account-profile-info .shimmer-text-line {
    height: 14px;
}

.profile-edit-application-dropdown .shimmer.shimmer-thumbnail.border-rounded {
    width: 233px;
    height: 70px !important;
}


.profile-activity-table .shimmer.shimmer-table-col {
    margin-bottom: 0px;
    margin-top: 0px;
    padding: 0px;
}

.shimmer-table-main-wrap > div{
    margin: 0px;
    padding: 0px;
    line-height: 0;
}

.shimmer-table-main-wrap .shimmer-table-row--header {
    background-color: transparent;
    box-shadow: none;
    margin: 0;
    padding: 15px;
}


/*************   Cart Shimmer Effect *********/
.service-item-grid .shimmer-card {
    width: 103px !important;
    height: 134px;
    border: 1px solid #f3f3f3;
    border-radius: 15px;
    box-shadow: unset;
    overflow: hidden;
}

.shimmer-service-item-card-wrap{
    margin-bottom: 20px;
}

.summer-effect-item-wrap{
    margin-top: 12px;
}

.shimmer.shimmer-thumbnail.mb-0 {
    height: 78px !important;
}

.service-item-grid .p-30 {
    padding: 4px 16px;
}

.summer-effect-item-wrap .shimmer-title--secondary .shimmer-title-line {
    height: 10px !important;
}

.service-item-grid .shimmer-title--secondary .shimmer-title-line {
    height: 10px !important;
}


.service-item-grid{
    display: flex;
    align-items: center;
}

/********** Edit profile shimmer css ******/
.edit-profile-address-wrap .shimmer.shimmer-thumbnail.border-rounded{
    width: 100%;
    min-height: 510px !important;
    border-radius: 34px;
    margin: 0px;
}

.edit-profile-services-wrap .shimmer.shimmer-thumbnail.border-rounded{
    border-radius: 9px;
    min-height: 400px;
    margin: 0px;
    margin-top: 40px;
}

.availabilty-shimmer-wrap{
    margin-top: 30px;
    margin-bottom: 30px;
}

.availabilty-shimmer-wrap .shimmer.shimmer-thumbnail.border-rounded{
    width: 100%;
    min-height: 333px;
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    padding: 30px 40px;
    margin: 0px;
}

.edit-profile-testing-wrap .shimmer.shimmer-thumbnail.border-rounded{
    height: 472px !important;
    border-radius: 34px;
}


.admin-user-table-wrapper .shimmer-table-row > .shimmer {
    margin: 0 50px;
}

.admin-user-table-wrapper .shimmer-table-row {
    padding: 5px 0;
}


@media (min-width: 1025px) and (max-width: 1599px) {

    .shimmer-account-profile-info .shimmer.shimmer-avatar{
        width: 100px !important;
        height: 100px !important;
    }

    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {
        height: 107px !important;
    }

    .service-item-grid .shimmer-card {
        width: 100px !important;
        height: 108px;
    }

    .summer-effect-item-wrap{
        margin-top: 0px;
    }


    .shimmer.shimmer-thumbnail.mb-0 {
        height: 60px !important;
    }

    .summer-effect-item-wrap .shimmer-title--secondary .shimmer-title-line {
        height: 6px !important;
    }
    
    .service-item-grid .shimmer-title--secondary .shimmer-title-line {
        height: 6px !important;
    }
}

@media (min-width: 1024px) and (max-width: 1199px) {
    .edit-profile-testing-wrap .shimmer.shimmer-thumbnail.border-rounded{
        height: 340px !important;
        border-radius: 26px;
    }
}

@media(max-width: 767px){
    .shimmer-account-profile-info {
        display: unset; 
        text-align: center;           
    }
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/Shimmer.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;;AAGA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;IACT,aAAa;AACjB;;;AAGA,8CAA8C;AAC9C;IACI,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;IACI,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;;IAEI;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ","sourcesContent":[".shimmer-account-profile-info .shimmer.shimmer-avatar{\n    width: 133px !important;\n    height: 133px !important;\n}\n\n.shimmer-account-profile-info > div {\n    line-height: 1;\n    margin: 0px;\n    padding: 0px;\n    gap: 0px;\n}\n\n.shimmer-account-profile-info {\n    display: flex;  \n    gap: 20px;              \n}\n\n\n.shimmer-account-profile-info .grid.shimmer-text.grid-gap-20 {\n    width: 400px;\n    gap: 20px;\n}\n\n.shimmer-account-profile-info .shimmer-text-line {\n    height: 14px;\n}\n\n.profile-edit-application-dropdown .shimmer.shimmer-thumbnail.border-rounded {\n    width: 233px;\n    height: 70px !important;\n}\n\n\n.profile-activity-table .shimmer.shimmer-table-col {\n    margin-bottom: 0px;\n    margin-top: 0px;\n    padding: 0px;\n}\n\n.shimmer-table-main-wrap > div{\n    margin: 0px;\n    padding: 0px;\n    line-height: 0;\n}\n\n.shimmer-table-main-wrap .shimmer-table-row--header {\n    background-color: transparent;\n    box-shadow: none;\n    margin: 0;\n    padding: 15px;\n}\n\n\n/*************   Cart Shimmer Effect *********/\n.service-item-grid .shimmer-card {\n    width: 103px !important;\n    height: 134px;\n    border: 1px solid #f3f3f3;\n    border-radius: 15px;\n    box-shadow: unset;\n    overflow: hidden;\n}\n\n.shimmer-service-item-card-wrap{\n    margin-bottom: 20px;\n}\n\n.summer-effect-item-wrap{\n    margin-top: 12px;\n}\n\n.shimmer.shimmer-thumbnail.mb-0 {\n    height: 78px !important;\n}\n\n.service-item-grid .p-30 {\n    padding: 4px 16px;\n}\n\n.summer-effect-item-wrap .shimmer-title--secondary .shimmer-title-line {\n    height: 10px !important;\n}\n\n.service-item-grid .shimmer-title--secondary .shimmer-title-line {\n    height: 10px !important;\n}\n\n\n.service-item-grid{\n    display: flex;\n    align-items: center;\n}\n\n/********** Edit profile shimmer css ******/\n.edit-profile-address-wrap .shimmer.shimmer-thumbnail.border-rounded{\n    width: 100%;\n    min-height: 510px !important;\n    border-radius: 34px;\n    margin: 0px;\n}\n\n.edit-profile-services-wrap .shimmer.shimmer-thumbnail.border-rounded{\n    border-radius: 9px;\n    min-height: 400px;\n    margin: 0px;\n    margin-top: 40px;\n}\n\n.availabilty-shimmer-wrap{\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.availabilty-shimmer-wrap .shimmer.shimmer-thumbnail.border-rounded{\n    width: 100%;\n    min-height: 333px;\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    padding: 30px 40px;\n    margin: 0px;\n}\n\n.edit-profile-testing-wrap .shimmer.shimmer-thumbnail.border-rounded{\n    height: 472px !important;\n    border-radius: 34px;\n}\n\n\n.admin-user-table-wrapper .shimmer-table-row > .shimmer {\n    margin: 0 50px;\n}\n\n.admin-user-table-wrapper .shimmer-table-row {\n    padding: 5px 0;\n}\n\n\n@media (min-width: 1025px) and (max-width: 1599px) {\n\n    .shimmer-account-profile-info .shimmer.shimmer-avatar{\n        width: 100px !important;\n        height: 100px !important;\n    }\n\n    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {\n        height: 107px !important;\n    }\n\n    .service-item-grid .shimmer-card {\n        width: 100px !important;\n        height: 108px;\n    }\n\n    .summer-effect-item-wrap{\n        margin-top: 0px;\n    }\n\n\n    .shimmer.shimmer-thumbnail.mb-0 {\n        height: 60px !important;\n    }\n\n    .summer-effect-item-wrap .shimmer-title--secondary .shimmer-title-line {\n        height: 6px !important;\n    }\n    \n    .service-item-grid .shimmer-title--secondary .shimmer-title-line {\n        height: 6px !important;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1199px) {\n    .edit-profile-testing-wrap .shimmer.shimmer-thumbnail.border-rounded{\n        height: 340px !important;\n        border-radius: 26px;\n    }\n}\n\n@media(max-width: 767px){\n    .shimmer-account-profile-info {\n        display: unset; \n        text-align: center;           \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
